import BeginnerTop from './beginner/BeginnerTop';
import BeginnerItem from './beginner/BeginnerItem';
import BeginnerMagic from './beginner/BeginnerMagic';
import BeginnerHunt from './beginner/BeginnerHunt';
import BeginnerRecommend from './beginner/BeginnerRecommend';

import { isNotDefined, namespace } from './../utils/util';
import { API_DOMAIN_DEFAULT } from './../model/model';
import { getDatasWithOption } from './../utils/service';

(function ($, global) {
  "use strict";
  namespace('nc.lineage');

  nc.lineage.beginner = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.beginner require options object');

    const option = $.extend(true, {
      apiDomain: API_DOMAIN_DEFAULT,
      classId: 0,
      level: 0,
      wrap: null
    }, options);

    let beginnerTop = new BeginnerTop(option).init();
    let beginnerItem = new BeginnerItem(option).init();
    let beginnerMagic = new BeginnerMagic(option).init();
    let beginnerHunt = new BeginnerHunt(option).init();
    let beginnerRecommend = new BeginnerRecommend(option).init();

  };

}(jQuery, window));


// WEBPACK FOOTER //
// ./_src/js/service/beginner.js